<template>
  <div id="app">
		<router-view></router-view>
  </div>
</template>

<script>

export default {
	name: 'app',
	metaInfo: {
		title: 'Административная панель Академии Наставников'
	}
}
</script>




// WEBPACK FOOTER //
// App.vue?22d3273b